export enum TodoTypeEnums {
  SELF = 'SELF',
  CLEAR_TODO = 'Clear TO-DO',
  ADDITIONAL_CONSENT_REQUIRED_TODO = 'additionConsentRequiredTodo',
  IDENTIFICATION_CARD_TODO = 'identificationCardTodo',
  REVIEW_PATIENT_TODO = 'reviewPatientTodo',
  PAYMENT_ISSUE_TODO = 'paymentIssueTodo',
  VERIFICATION_PROVIDER_TODO = 'verifyProviderTodo',
  DISPUTE_PAYMENT_TODO = 'disputePaymentTodo',
  INSURANCE_REQUEST_TODO = 'newInsuranceRequestTodo',
  EHR_USER_CREATION_FAILED_TODO = 'ehrUserCreationFailedTodo',
  PROVIDER_APPOINTMENT_CONFIRMATION_TODO = 'providerAppointmentConfirmationTodo',
  PROVIDER_JOIN_REQUEST_TODO = 'providerJoinRequestTodo',
  PRACTICE_OWNER_JOIN_REQUEST_TODO = 'practiceOwnerJoinRequestTodo',
}
